import { useTranslation } from 'react-i18next'

import { GENERATOR_INPUT_TYPE } from '@constants'

export const useInputs = ({ isEdit }: { isEdit: boolean }) => {
  const { t } = useTranslation()

  const generalInputs = [
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'code',
      label: t('mapCreateOrEdit.internalId'),
      placeholder: t('mapCreateOrEdit.internalIdPlaceholder'),
      disabled: isEdit,
      rules: { required: true },
      gridProps: { xs: 12 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'title',
      label: t('mapCreateOrEdit.title'),
      placeholder: t('mapCreateOrEdit.titlePlaceholder'),
      rules: { required: true },
      gridProps: { xs: 12 },
    },
  ]

  return {
    generalInputs,
  }
}
